export const ofacCountries = [
  "Belarus",
  "Burma",
  "Burindi",
  "Central African Republic",
  "Côte d'Ivoire",
  "Cuba",
  "Congo, Democratic Republic of the",
  "Iran, Islamic Republic of",
  "Iraq",
  "Liberia",
  "Lebanon",
  "Nicaragua",
  "Korea, Democratic People's Republic of",
  "Sudan",
  "Syrian Arab Republic",
  "Somalia",
  "Zimbabwe",
  "Yemen",
  "Ukraine",
  "Albania",
  "Bosnia and Herzegovina",
  "Bulgaria",
  "Burundi",
  "Croatia",
  "Kosovo",
  "North Macedonia",
  "Moldova, Republic of",
  "Montenegro",
  "Romania",
  "Serbia",
  "Mali",
];
